import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconPersonLimited(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M12 10c.18 0 .353-.024.518-.068l-2.45-2.45A1.999 1.999 0 0 0 12 10Zm-.518-3.932 2.45 2.45a1.999 1.999 0 0 0-2.45-2.45ZM16 8c0 2.21-1.79 4-4 4s-4-1.79-4-4 1.79-4 4-4 4 1.79 4 4ZM4 18c0-2.66 5.33-4 8-4s8 1.34 8 4v2H4v-2Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
